<template>
  <LayoutContent>
    <SectionTitle :label="$t('label.transactionHistory')" />
    <p v-if="member" class="mb-4 text-h6 font-weight-bold orange--text">{{ member.full_name }}</p>
    <v-data-table
      :items="orders"
      :headers="headers"
      :item-class="rowClasses"
      hide-default-footer
      :page.sync="page"
      class="transparent transaction-history-table"
      v-if="$vuetify.breakpoint.smAndUp"
      :no-data-text="$t('message.noDataInTable')"
    >
      <template #item.unit_price="{ item }">
        <span class="primary--text text--darken-1 font-weight-medium text-body">SGD {{ parseInt(item.unit_price).toFixed(2) }}</span>
      </template>
    </v-data-table>
    <div v-if="!$vuetify.breakpoint.smAndUp">
      <v-card v-for="(transaction, i) in list" :key="i" class="my-4 white">
        <v-card-title class="primary--text text--darken-1 text-subtitle-1 pb-1 font-weight-medium">{{ transaction[0] | shortDate('DD/MM/YYYY') }}</v-card-title>
        <v-card-text v-for="(record, j) in transaction[1]" :key="j" class="pt-0">
          <span>{{ $t('label.orderId') }} {{ record.po_number }}</span>
          <div class="d-flex flex-row justify-space-between">
            <div class="grey--text text--darken-1 font-weight-medium">
              <p class="">{{ record.product_name }}</p>
              <p>{{ $t('label.qty') }}: {{ record.quantity }}</p>
            </div>
            <span class="primary--text text--darken-1 font-weight-bold text-body">SGD {{ formatPrice(record.unit_price) }}</span>
          </div>
        </v-card-text>
      </v-card>
      <div v-if="list.length === 0" class="blank-message text-h6 font-weight-medium grey--text text-center">{{ $t('message.noTransactionInRecord') }}</div>
    </div>
  </LayoutContent>
</template>

<script>
import { mapActions } from 'vuex'
import { uiHelper, localeHelper } from '@/utils'
import LayoutContent from '@/views/layouts/LayoutContent.vue'
import SectionTitle from '@/components/SectionTitle.vue'

export default {
  name: 'MemberTransactionHistory',
  components: {
    SectionTitle,
    LayoutContent
  },
  data: () => ({
    page: 1,
    member: null,
    orders: [],
    headers: [
      { text: localeHelper.getMessage('label.date'), value: 'date' },
      { text: localeHelper.getMessage('label.orderId'), value: 'po_number' },
      { text: localeHelper.getMessage('label.product'), value: 'product_name' },
      { text: localeHelper.getMessage('label.quantity'), value: 'quantity' },
      { text: localeHelper.getMessage('label.unitPrice'), value: 'unit_price' }
    ]
  }),
  created() {
    this.getMemberTransaction({ member_user_id: parseInt(this.$route.params.memberId) }).then((res) => {
      this.member = res.member
      res.orders.map((f) => {
        f.details.map((g, i) => {
          this.orders.push({ po_number: i === 0 ? f.po_number : '', date: i === 0 ? f.date : '', ...g })
        })
      })
    })
  },
  computed: {
    list() {
      let arr = this.groupBy(this.orders, (v) => v.date)
      return Object.entries(arr)
    }
  },
  methods: {
    ...mapActions('agent', ['getMemberTransaction']),
    rowClasses(rowItem) {
      if (rowItem.date) {
        return 'has-date'
      }
    },
    groupBy(x, f) {
      return x.reduce((a, b) => ((a[f(b)] ||= []).push(b), a), {})
    },
    formatPrice(val) {
      return uiHelper.priceFormatter(parseFloat(val))
    }
  }
}
</script>

<style lang="scss" scoped>
/* clears default header and middle table row borders */
::v-deep .v-data-table {
  th,
  td {
    border-bottom: unset !important;
  }

  /* add top border for rows with dates */
  .has-date:not(:first-of-type) td {
    border-top: thin solid $shadow-key-ambient-opacity;
  }
}

::v-deep .transaction-history-table .v-data-table__wrapper {
  min-height: 20rem;
}

::v-deep .page-input {
  width: 5rem;
  flex-grow: 0;

  .v-input__slot {
    padding-left: 0.4rem !important;
    padding-right: 0.4rem !important;

    input {
      text-align: right;
    }
  }

  .v-input__append-outer {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
}
</style>
